import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  kuud

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  мес.
*/
/* @__NO_SIDE_EFFECTS__ */
const m802 = msg(
  mf`kuud`,
  mf``,
  mf`мес.`,
)

export { m802 as 'w.menu.jm.kuud' }